import React from 'react';
import TextBlock from "../blocks/TextBlock";
import ProgramCodeBlock from "../blocks/ProgramCodeBlock";

const CheatsheetRenderer = ({content}) => {

    if (!content || typeof content !== 'object') {
        return null;
    }

    const blocks = Array.isArray(content.blocks)
        ? content.blocks
        : [];

    if (blocks.length === 0) {
        return (
            <div className="py-8 text-center text-gray-500">
                این تقلب‌نامه هنوز محتوایی ندارد.
            </div>
        );
    }

    const renderBlock = (block) => {

        if (!block || !block.type) {
            return null;
        }

        const config = block.config || {};

        switch (block.type) {

            case 'text':
                return (
                    <TextBlock
                        key={block.id}
                        config={config} />
                );

            case 'code':
                return (
                    <ProgramCodeBlock config={config} />
                );

            case 'link':
                return (
                    <a
                        key={block.id}
                        href={config.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-700 hover:underline"
                    >
                        {config.text || config.url}
                    </a>
                );

            default:
                return null;
        }
    };

    return (
        <div className="flex flex-col gap-6">
            {blocks.map(renderBlock)}
        </div>
    );
};

export default CheatsheetRenderer;
